import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { callsApi } from '../api/callsApi';
import { callsKeys } from '../queryKeys';

export function useCallAvailableNumbers(excludeAgentId?: string) {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  const query = useQuery({
    queryKey: callsKeys.availableNumbersFor(locationId, excludeAgentId),
    queryFn: () => callsApi.listAvailableNumbers(locationId, excludeAgentId),
    enabled: !!locationId,
    staleTime: 30 * 1000,
  });

  return { ...query, availableNumbers: query.data ?? [], locationId };
}
